
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "class": "icon",
    "width": "200px",
    "height": "200.00px",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M894.528 150.4a195.072 195.072 0 0 0-270.912-52.288L359.424 276.992a195.072 195.072 0 0 0-52.16 270.912c56.768 83.904 167.04 108.288 254.208 60.736l-0.384-0.832c1.92-0.896 3.904-1.216 5.76-2.432a34.496 34.496 0 1 0-35.52-59.2H531.2l-0.448-0.768c-57.344 34.56-128.64 24.128-166.656-32.064a127.552 127.552 0 0 1 34.112-177.152l258.816-175.168a127.552 127.552 0 0 1 177.152 34.112c39.488 58.368 26.816 127.488-31.552 166.976l-39.488 27.52a35.392 35.392 0 1 0 39.68 58.624c0.32-0.192 0.448-0.576 0.768-0.768l38.72-26.176a195.072 195.072 0 0 0 52.224-270.912z",
        "fill": "#ffffff"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M453.888 411.328l0.448 0.832c-1.92 0.896-3.968 1.28-5.76 2.56a34.496 34.496 0 1 0 36.992 58.24l0.064 0.128 0.512 0.64c56.448-35.968 128-27.264 167.424 28.032 40.96 57.344 27.584 136.96-29.76 177.92L369.28 861.184c-57.344 40.896-136.96 27.52-177.92-29.76-40.896-57.344-29.952-126.784 27.456-167.68l38.784-28.544a35.392 35.392 0 1 0-41.088-57.6c-0.32 0.192-0.448 0.576-0.768 0.768l-38.08 27.136a195.072 195.072 0 0 0 226.56 317.632l259.712-185.28a195.072 195.072 0 0 0 45.504-272.128c-58.816-82.432-169.6-104.064-255.616-54.4z",
        "fill": "#ffffff"
      }
    }
  ]
})
    }
  